/**
 * 教练模块接口列表
 */
import { get, post } from '../http'; // 导入http中创建的axios实例
export const coach = {
    // 获取教练训练日历
    getCoachTaskDate(params) {
        return get(`${process.env.VUE_APP_BASE_API}/train/date`, params);
    },
    //获取教练信息-下拉列表 
    getCoachSelectList() {
        return get(`${process.env.VUE_APP_BASE_API}/coach/selectList`);
    },
    // 学员签到
    signUpdate(params) {
        return post(`${process.env.VUE_APP_BASE_API}/sign/update`, params);
    },
    // 获取学员训练日期
    getStudentTrainDate(data) {
        return get(`${process.env.VUE_APP_BASE_API}/train/date/info/${data.coachId}?type=${data.type}&currentDate=${data.currentDate}`);
    },
    // 获取当天训练
    getTrainInfo(params) {
        return get(`${process.env.VUE_APP_BASE_API}/train/date/trainInfo`, params);
    },
    //根据日期获取教练任务
    getTrainCurrentInfo(params) {
        let data = {
            currentDay: params.currentDay
        }
        return get(`${process.env.VUE_APP_BASE_API}/train/date/${params.trainType}/${params.trainId}`, data);
    },
    // 教练评价

    coachEvaluateAdd(params) {
        return post(`${process.env.VUE_APP_BASE_API}/coach/evaluate/add`, params);
    },

    coachEvaluateUpdate(params) {
        return post(`${process.env.VUE_APP_BASE_API}/coach/evaluate/update`, params);
    },
    //回显教练学员评价
    getCoachjEvalute(params) {
        return get(`${process.env.VUE_APP_BASE_API}/coach/evaluate/date/${params.studentId}/${params.trainId}/${params.coachId}
`, { currentDate: params.currentDate });
    },
    // 教练学员评价提交
    coachSubimit(params) {
        return post(`${process.env.VUE_APP_BASE_API}/coach/evaluate/submit`, params);
    },
    // 添加记分卡
    addScoreCard(params) {
        return post(`${process.env.VUE_APP_BASE_API}/score/card/add`, params);
    },
    // 查询记分卡
    searchScoreCard(params) {
        return get(`${process.env.VUE_APP_BASE_API}/score/card/${params.trainId}/${params.studentId}?type=${params.type}`)
    },
    // 同步学员list
    syncStudent(params) {
        return get(`${process.env.VUE_APP_BASE_API}/train/stu/${params.studentId}/${params.trainId}`);
    }
}


